module.exports = __webpack_public_path__ + "img/dropbox.b8b49743.svg";